export default {"src":"/_next/static/media/import-ethereum.7cbfee17.svg","height":64,"width":64};